import React from 'react'
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers";
import Grid from "@material-ui/core/Grid";
import CheckedInOperatorText from "../checkin3/CheckedInOperatorText";
import {TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import BaseAdHocPage from "../../framework/util/uicomps/BaseAdHocPage";
import PressPalletIcon from "./PressPalletIcon";

const FinishedPrintingManifest = () => {

    const baseContentItems = [];

    const buttonItems = [];


    return (
        <BaseAdHocPage icon={<PressPalletIcon/>} title={'Print Request Sent'}
                       description={'Choose another action from the side menu to continue'} buttons={buttonItems}
                       content={baseContentItems}/>
    );


}

export default FinishedPrintingManifest;